import { defineStore } from 'pinia'
import { readonly, ref } from 'vue'

import api from '@/client/core/api'
import { TGetSerialCodeParam, TGetSerialCodeResponse } from '@/typings/api/twitter_serial_codes.type'

type SerialCode = {
  loaded: boolean
  list: any[]
  total: number
  countAssign: number
  countUnassign: number
  params: TGetSerialCodeParam
  isCreated: boolean
}

type SerialCodeDialogState = {
  campaignId: number
  prizeId: number
  serialCode: SerialCode
}

const createInitialState = (): SerialCodeDialogState => ({
  campaignId: 0,
  prizeId: 0,
  serialCode: {
    loaded: false,
    list: [],
    total: 0,
    countAssign: 0,
    countUnassign: 0,
    params: {
      campaignId: 0,
      prizeId: 0,
      filter: '',
      sortBy: '-tw_campaign_message_id',
      pagingNo: 1,
      limitCount: 25,
      type: ''
    },
    isCreated: false
  }
})

export const useTwitterSerialCodeDialogStore = defineStore('twitterSerialCodeDialogStore', () => {
  const initialState = createInitialState()

  const campaignId = ref<SerialCodeDialogState['campaignId']>(initialState.campaignId)
  const prizeId = ref<SerialCodeDialogState['prizeId']>(initialState.prizeId)
  const serialCode = ref<SerialCodeDialogState['serialCode']>(initialState.serialCode)

  const reset = async (): Promise<void> => {
    const nextState = createInitialState()
    campaignId.value = nextState.campaignId
    prizeId.value = nextState.prizeId
    serialCode.value = nextState.serialCode
  }

  const setCampaignId = (id: number): void => {
    campaignId.value = id
    serialCode.value.params.campaignId = id
  }

  const setPrizeId = (id: number): void => {
    prizeId.value = id
    serialCode.value.params.prizeId = id
  }

  const fetchSerialCodeList = async (): Promise<void> => {
    if (!prizeId.value || !campaignId.value) {
      return
    }
    const result: TGetSerialCodeResponse = await api.get('/twitter_serial_codes', {
      params: serialCode.value.params
    })
    if (!result.data) {
      return
    }
    serialCode.value.list = result.data.serialCode
    serialCode.value.total = result.data.dataCount
    serialCode.value.countAssign = result.data.count.assign
    serialCode.value.countUnassign = result.data.count.unassign
  }

  const setSerialCodeListParams = (newParams: Partial<TGetSerialCodeParam>): void => {
    serialCode.value.params = { ...serialCode.value.params, ...newParams }
  }

  const setSerialCodeIsCreated = (isCreated: boolean): void => {
    serialCode.value.isCreated = isCreated
  }

  return {
    campaignId: readonly(campaignId),
    prizeId: readonly(prizeId),
    serialCode: readonly(serialCode),
    reset,
    setCampaignId,
    setPrizeId,
    fetchSerialCodeList,
    setSerialCodeListParams,
    setSerialCodeIsCreated
  }
})
